import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        userName: "",
        role: -1,
        user: "",

    },
    mutations: {
        setUsername(state, userName) {
            state.userName = userName;
        },
        setUserRole(state, role) {
            state.role = role;
        },
        setUser(state, user) {
            state.user = user;
        }
    },
    actions: {},
    modules: {},
    getters: {
        getUsername: state => state.userName,
        getUserRole: state => state.role,
        getUser: state => state.user,

    }
})